import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface CommandConfirmModalProps {
  show: boolean;
  command: string;
  onConfirm: (command: string) => void;
  onChange: (command: string) => void;
  onBack: () => void;
}

export const CommandConfirmModal: React.FC<CommandConfirmModalProps> = ({
  show,
  command,
  onConfirm,
  onChange,
  onBack,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !isFocused && show) {
        e.preventDefault();
        onConfirm(command);
      }
    };

    document.addEventListener('keypress', handleKeyPress);
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, [command, onConfirm, show, isFocused]);

  return (
    <Modal show={show} onHide={onBack}>
      <Modal.Header closeButton>
        <Modal.Title>确认命令</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          ref={textAreaRef}
          as="textarea"
          value={command}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          rows={3}
          style={{
            outline: isFocused ? 'auto' : 'none',
          }}
        />
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onBack} title="返回自然语言输入，保留之前的输入内容">
          ‹ 返回修改
        </Button>
        <Button variant="primary" onClick={() => onConfirm(command)}>
          确认（Enter）
        </Button>
      </Modal.Footer>
    </Modal>
  );
}; 